import {
  IntegrationChannelType,
  ScheduleViewFragment,
  SlackChannelInput,
} from 'generated/graphql';

export const getSlackChannelsFromReportSchedule = (
  reportSchedule?: ScheduleViewFragment,
) => {
  const slackChannels =
    reportSchedule?.integrations
      ?.filter(
        (integration) =>
          integration.channel.type === IntegrationChannelType.Slack &&
          integration.isActive,
      )
      ?.map((integration) => integration.data.slack?.subscribedChannels ?? [])
      ?.flat()
      ?.map(
        (channel): SlackChannelInput => ({
          id: channel.id,
          name: channel.name,
          isPrivate: channel.isPrivate,
        }),
      ) ?? [];

  return slackChannels;
};
